import { Component } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'lib-field-tag-icon',
  template: `
    <svg
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      [class]="iconClass()"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.47532 12.7502L7.25032 16.5252C8.80032 18.0752 11.317 18.0752 12.8753 16.5252L16.5337 12.8668C18.0837 11.3168 18.0837 8.80016 16.5337 7.24183L12.7503 3.47516C11.9587 2.6835 10.867 2.2585 9.75032 2.31683L5.58365 2.51683C3.91698 2.59183 2.59198 3.91683 2.50865 5.57516L2.30865 9.74183C2.25865 10.8668 2.68365 11.9585 3.47532 12.7502Z"
        stroke="#D97706"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M7.91732 9.99967C9.06791 9.99967 10.0007 9.06693 10.0007 7.91634C10.0007 6.76575 9.06791 5.83301 7.91732 5.83301C6.76672 5.83301 5.83398 6.76575 5.83398 7.91634C5.83398 9.06693 6.76672 9.99967 7.91732 9.99967Z"
        stroke="#D97706"
        stroke-width="1.5"
        stroke-linecap="round" />
    </svg>
  `,
})
export class FieldTagIconComponent extends BaseIconComponent {}
